module.exports = __webpack_public_path__ + "static/media/blackcar.54664972.png";